import { createContext, useContext } from "react";

/**
 * Which mobile presentation target the current window is being rendered into,
 * plus whether that target is currently visible on-screen. Provided by
 * `SidePanel` and `Drawer` respectively, `null` on desktop or outside a mobile
 * chrome wrapper.
 *
 * Consumers reading this include `SlottedWindow`, which uses `target` to pick
 * drawer-appropriate chrome (drawer = only close button in header) and uses
 * `isOpen` to decide whether the portaled FAB should render — the drawer stays
 * mounted while animating closed, so its children (including `SlottedWindow`)
 * keep receiving `target === "drawer"` even when the drawer is off-screen.
 */
export type WindowMobileTargetKind = "sidePanel" | "drawer";

export interface WindowMobileTarget {
    target: WindowMobileTargetKind;
    /** Whether the target is currently visible on-screen. */
    isOpen: boolean;
}

export const WindowMobileTargetContext = createContext<WindowMobileTarget | null>(null);

export function useWindowMobileTarget(): WindowMobileTarget | null {
    return useContext(WindowMobileTargetContext);
}
